<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useXpressBottomNavigation } from '@/composables/Layout/useXpressBottomNavigation'
import { usePatientMiniInfo } from '@/composables/Patient/usePatientMiniInfo'
import { usePatientMemberCard } from '@/composables/Patient/usePatientMemberCard'

type NavigationItem = {
  icon: string
  activeIcon: string
  label: string
  to: string
  active: boolean
}

const route = useRoute()
const router = useRouter()
const { getNavigationItems } = useXpressBottomNavigation()
const { initPatient } = usePatientMiniInfo()
const { fetchMemberCard } = usePatientMemberCard()

const navigationItems = computed<NavigationItem[]>(() => {
  const currentRouteName = route.name as string
  const items = getNavigationItems()
  return items.map(item => ({
    ...item,
    active: item.to === currentRouteName,
  }))
})

onMounted(async () => {
  const patient = await initPatient()
  if (patient && patient.uuid) {
    await fetchMemberCard(patient.uuid)
  }
})
</script>

<template>
  <div
    class="tw-fixed tw-bottom-0 tw-w-full tw-h-[71px] tw-grid tw-grid-cols-3 tw-bg-white tw-border-t-[1px] tw-px-2 tw-py-3"
  >
    <div
      v-for="item in navigationItems"
      :key="item.to"
      @click="router.push({ name: item.to })"
      class="tw-min-w-0 tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all tw-duration-200 hover:tw-opacity-80"
    >
      <div
        class="tw-flex tw-flex-row tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-py-2 tw-rounded-full"
        :class="{ 'tw-bg-gray-100': item.active }"
      >
        <div :class="item.active ? 'text-primary2' : 'tw-text-gray-400'">
          <v-icon :size="28" v-if="item.active">mdi-{{ item.activeIcon }}</v-icon>
          <v-icon :size="28" v-else>mdi-{{ item.icon }}</v-icon>
        </div>
        <div
          v-if="item.active"
          class="tw-text-xs tw-text-center tw-whitespace-nowrap tw-transition-all tw-duration-200 tw-font-bold"
          :class="item.active ? 'text-primary2' : 'tw-text-gray-400'"
        >
          {{ item.label }}
        </div>
      </div>
      <div v-if="item.active" class="tw-w-1 tw-h-1 bg-primary tw-rounded-full tw-mt-1"></div>
    </div>
  </div>
</template>

<style scoped></style>
